// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1WFgv","info":"UpdateTermsInfo_info__hDpv-"};